import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgScissor = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M21.77 16.08L16.38 12.57L15.46 13.16L20.74 16.6L20.49 16.88C20.11 17.29 19.66 17.33 17.92 16.47L13.5 14.42L12.5 15.06L17.48 17.37C18.37 17.81 19.17 18.17 19.87 18.17C20.37 18.17 20.82 17.99 21.22 17.55L21.86 16.83C21.96 16.72 22 16.58 21.98 16.43C21.96 16.29 21.88 16.16 21.76 16.08H21.77Z' />
    <path d='M21.78 7.92C21.9 7.84 21.98 7.72 22 7.58C22.02 7.44 21.98 7.3 21.89 7.19L21.26 6.42C20.28 5.31 18.84 5.89 17.45 6.58L4.15 13.46C2.83 14.15 2 15.51 2 17C2 19.21 3.79 21 6 21C8.21 21 10 19.21 10 17C10 16.53 9.92 16.08 9.76 15.64L21.77 7.91L21.78 7.92ZM6 20C4.35 20 3 18.65 3 17C3 15.88 3.62 14.86 4.61 14.34L17.9 7.47C19.62 6.62 20.16 6.68 20.5 7.06L20.76 7.38L8.87 15.03C8.66 15.17 8.58 15.44 8.69 15.67C8.9 16.09 9 16.53 9 17C9 18.65 7.65 20 6 20Z' />
    <path d='M4 7C4 8.1 4.9 9 6 9C7.1 9 8 8.1 8 7C8 5.9 7.1 5 6 5C4.9 5 4 5.9 4 7ZM7 7C7 7.55 6.55 8 6 8C5.45 8 5 7.55 5 7C5 6.45 5.45 6 6 6C6.55 6 7 6.45 7 7Z' />
    <path d='M6 14.97C4.9 14.97 4 15.87 4 16.97C4 18.07 4.9 18.97 6 18.97C7.1 18.97 8 18.07 8 16.97C8 15.87 7.1 14.97 6 14.97ZM6 17.97C5.45 17.97 5 17.52 5 16.97C5 16.42 5.45 15.97 6 15.97C6.55 15.97 7 16.42 7 16.97C7 17.52 6.55 17.97 6 17.97Z' />
    <path d='M11.5 12.5C11.7761 12.5 12 12.2761 12 12C12 11.7239 11.7761 11.5 11.5 11.5C11.2239 11.5 11 11.7239 11 12C11 12.2761 11.2239 12.5 11.5 12.5Z' />
    <path d='M4.13 10.54L5.8 11.47L6.87 10.92L4.6 9.66C3.61 9.14 2.99 8.12 2.99 7C2.99 5.35 4.34 4 5.99 4C7.64 4 8.99 5.35 8.99 7C8.99 7.47 8.89 7.91 8.68 8.33C8.57 8.56 8.64 8.84 8.86 8.97L9.65 9.48L10.68 8.95L9.76 8.36C9.92 7.93 10 7.47 10 7C10 4.79 8.21 3 6 3C3.79 3 2 4.79 2 7C2 8.49 2.82 9.85 4.13 10.54Z' />
  </svg>
);
export default SvgScissor;
